import React, {
  useEffect,
  useState,
} from 'react';

import values from 'lodash/values';

import FilterItem, { FilterItemProps } from './FilterItem';

enum FilterTypes {
    filterByDateCall = 'filterByDateCall',
    filterByRegion = 'filterByRegion',
    filterByDistrict = 'filterByDistrict',
    filterByOutlet = 'filterByOutlet',
    filterByRep = 'filterByRep',
    filterByType = 'filterByType',
    filterByCompletedCall = 'filterByCompletedCall',
    filterByCallListActivity = 'filterByCallListActivity',
}

enum FilterLimitKeys {
    filterByRegion = 'region_id',
    filterByDistrict = 'district_id',
    filterByOutlet = 'outlet_id',
}

enum FilterLimitBy {
    filterByDistrict = 'region',
    filterByOutlet = 'district',
    filterByRep = 'outlet',
}

enum LimitLink {
    filterByRegion = 'filterByDistrict',
    filterByDistrict = 'filterByOutlet',
    filterByOutlet = 'filterByRep',
}

export interface FilterProps {
    filters: FilterItemProps[];
    selected: any;
    translate?: (string) => string;
    onApply?: (value) => void;
    onCancel?: () => void;
    onClose?: () => void;
    onReset?: () => void;
}

const Filter: React.FC<FilterProps> = ({ filters, translate, selected, onApply, onCancel, onClose, onReset }) => {
    const [options, setOptions] = useState([]);
    const [selections, setSelections] = useState(selected);
    const [limits, setLimits] = useState({});
    const [doReset, setDoReset] = useState(false);

    const setFilters = (reset = doReset) => {
        const opts = [];

        filters.forEach((filter) => {
            if (filter.key === FilterTypes.filterByDateCall) {
                opts.push({
                    ...filter,
                    limitBy: null,
                    limitKey: null,
                    value: `${selected.year}-${selected.month}`,
                    reset
                });
            }

            if (filter.key !== FilterTypes.filterByDateCall) {
                const itemSelected = values(filter.data).filter(item => item.selected);
                const preSelected = selected[FilterTypes[filter.key]];
                const all = values(filter.data).filter(item => item.name === 'All');

                opts.push({
                    ...filter,
                    reset,
                    limitBy: FilterLimitBy[filter.key] || null,
                    limitKey: FilterLimitKeys[filter.key] || null,
                    value: preSelected ? preSelected :
                        (itemSelected.length === 0 && all.length === 1) ? all[0].id :
                        (itemSelected.length === 1) ? itemSelected[0].id : ''
                });
            }
        });
        setOptions(opts);
        setSelections(selected);
    };

    useEffect(() => {
        setFilters();
        const selectedFilters = sessionStorage.getItem('selectedFiltersStorage');
        if (selectedFilters) {
            const selectedFiltersObj = JSON.parse(selectedFilters);
            selected = selectedFiltersObj;
        }
    }, [filters]);

    useEffect(() => {
        setFilters();
        const selectedFilters = sessionStorage.getItem('selectedFiltersStorage');
        if (selectedFilters) {
            const selectedFiltersObj = JSON.parse(selectedFilters);
            selected = selectedFiltersObj;
        }
        setSelections(selected);
    }, [selected]);

    // onApply create object with options
    const handleFilterChange = (name, value, limit) => {
        const opts = { ...selections };
        if (name === FilterTypes.filterByDateCall) {
            const split = value.split('-');
            opts.month = split[1];
            opts.year = split[0];
        }

        if (name !== FilterTypes.filterByDateCall) {
            if (value !== '0' && value !== 'all') {
                opts[FilterTypes[name]] = value;
            }

            if (value === '0' || value.toLowerCase() === 'all') {
                delete opts[FilterTypes[name]];
            }
        }

        if (LimitLink[name]) {
            setLimits({
                ...limits,
                [LimitLink[name]]: limit !== 'All' ? limit : null
            });
        }
        sessionStorage.setItem('selectedFiltersStorage', JSON.stringify(opts));
        setSelections(opts);
    };

    const handleApply = () => {
        if (onApply) {
            onApply(selections);
        }
    };

    const handleReset = () => {
        setLimits({});
        sessionStorage.removeItem('selectedFiltersStorage');
        if (selections !== selected) {
            setFilters(!doReset);
            setDoReset(!doReset);
        }
        if (onReset) {
            onReset();
        }
    };

    return (
        <div className="sl__filter">
            <div className="sl__filter__header">
                <span className="sl__filter__title">{translate('filters')}</span>
                <div className="sl__filter__close" onClick={onClose}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18" stroke="#187C92" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M6 6L18 18" stroke="#187C92" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="sl__filter__body">
                {options.map(filter => {
                    return (FilterTypes[filter.key]) ?
                        <FilterItem
                            key={filter.key}
                            label={filter.label}
                            name={filter.key}
                            value={filter.value}
                            data={filter.data}
                            reset={filter.reset}
                            limitBy={filter.limitBy}
                            limitKey={filter.limitKey}
                            limitValue={limits[filter.key] || null}
                            sort={(filter.key === FilterTypes.filterByDateCall) ? null : 'name'}
                            onChange={handleFilterChange}
                        />
                        : null;
                })}
            </div>
            <div className="sl__filter__footer">
                <div>
                    <button type="button" className="sl__filter__action__btn outlined" onClick={onCancel}>{translate('cancel')}</button>
                    <button type="button" className="sl__filter__action__btn ghost" onClick={handleReset}>{translate('reset')}</button>
                </div>
                <div>
                    <button type="button" className="sl__filter__action__btn solid" onClick={handleApply}>{translate('apply')}</button>
                </div>
            </div>
        </div>
    );
};

export default Filter;



// WEBPACK FOOTER //
// ./src/sections/SmartList/Filter.tsx